import { render, staticRenderFns } from "./packs.vue?vue&type=template&id=77545184"
import script from "./packs.vue?vue&type=script&lang=js"
export * from "./packs.vue?vue&type=script&lang=js"
import style0 from "./packs.vue?vue&type=style&index=0&id=77545184&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports